import { render } from "./PageDocs.vue?vue&type=template&id=69e7a948"
import script from "./PageDocs.vue?vue&type=script&lang=js"
export * from "./PageDocs.vue?vue&type=script&lang=js"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__